import { Card } from "~/screens/Hub/Home/components";
import { Resource } from "~/shared.types";
import { Slider } from "~/shared/components/ui/Slider/Slider";
import { icons } from "~/ui/common/Icons";

interface Meno101SectionProps {
  resources: Resource[];
}

export const Meno101Section = ({ resources }: Meno101SectionProps) => (
  <section>
    <Slider
      title="Meno 101"
      items={
        resources.map((item: Resource) => (
          <a
            href={item.link}
            target="_blank"
            className="block"
            rel="noopener noreferrer"
          >
            <Card
              key={item.id}
              className="hover:outline-violet h-full shrink-0 grow-0 flex-col justify-between space-y-1 overflow-hidden p-0 hover:outline-2 hover:outline-offset-[-2px]"
            >
              <img
                src={item.content?.imageUrl ?? item.content?.iconUrl}
                alt=""
                className="w-full"
              />
              <section className="flex h-full w-full items-center justify-between gap-1 p-4">
                <h3 className="text-indigo font-sans text-xl">{item.title}</h3>
                <icons.outline.ArrowRightCircleIcon className="text-violet size-10 shrink-0 stroke-1" />
              </section>
            </Card>
            <span className="sr-only"> (opens in a new tab)</span>
          </a>
        )) ?? []
      }
    />
  </section>
);
